import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Table } from 'shared/ui/TableNew'
import { Typography } from 'shared/ui'
import { useAddMembersContext } from 'pages/settings/pages/members/pages/addMembers/context/addMembersContext'
import { getInviteCandidatesColumns } from './columns'
import styles from './styles.module.scss'

export const InviteCandidatesTable = observer(() => {
  const { inviteCandidateRows, removeInviteCandidate, tableStore, isSendingInvites } =
    useAddMembersContext()
  const columns = useMemo(() => getInviteCandidatesColumns(), [])

  const rows = inviteCandidateRows.map((candidate) => {
    candidate.setActionsProps({
      noVisibleActions: false,
      actions: [
        {
          iconButtonProps: {
            icon: 'delete',
            fontSize: 16,
            size: 'small',
            ariaLabel: 'RemoveInviteCandidate',
            disabled: isSendingInvites,
          },
          onAction: () => removeInviteCandidate(candidate.id),
        },
      ],
    })

    return candidate
  })

  return (
    <div className={styles.container}>
      <Typography
        variant='heading-sm'
        ariaLabel='InviteCandidatesTable_title'
        className={styles.sectionTitle}
      >
        Invitation list
      </Typography>

      <Table
        ariaLabel='InviteCandidatesTable'
        rows={rows}
        columns={columns}
        store={tableStore}
        hidePagination
        emptyStateProps={{
          text: 'Added members will appear here',
          noIcon: true,
          boxProps: {
            minHeight: '98px',
          },
        }}
        scrollbarProps={{
          autoHeight: true,
          height: 'auto',
          autoHeightMax: 600,
        }}
      />
    </div>
  )
})
